/**
 * Owner: Haselton Baker Risk Group, LLC
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/30/19
 * Copyright All Rights Reserved
 */

import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import throttle from 'lodash/throttle';

import { loadState, saveState } from 'support/localStorageHelpers';
import rootReducer from 'reducers';

let middleware = [thunkMiddleware, promiseMiddleware];
if (process.env.NODE_ENV !== 'production') {
  middleware = [...middleware, createLogger()];
}

/**
 * Read persisted data from local storage
 */
const persistedState = loadState();

function configureStore() {
  return createStore(
    rootReducer,
    persistedState,
    composeWithDevTools(applyMiddleware(...middleware))
  );
}

const store = configureStore();

/**
 * Listen for changes to the Redux store and, when throttle allows, save slices of the store
 * to local storage
 */
store.subscribe(throttle(() => {
  const { token, users: { current } } = store.getState();
  saveState({ token, users: { current } });
}, 1000));

export default store;



// WEBPACK FOOTER //
// ./js/store/index.js